export function isBillingGeoRequest(url = '') {
  return (
    url.includes('/billing/plans') ||
    url.includes('/billing/public/plans') ||
    url.includes('/billing/checkout')
  );
}

export function getBillingGeoHeaders({ url, geo, isDevelopment }) {
  if (!isDevelopment || !isBillingGeoRequest(url)) {
    return {};
  }

  const headers = {};

  if (geo?.countryCode) {
    headers['X-Country-Code'] = geo.countryCode;
  }

  if (geo?.priceRegion) {
    headers['X-Billing-Price-Region'] = geo.priceRegion;
  }

  return headers;
}
